import { Component, OnInit } from '@angular/core';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject } from 'rxjs';
import { StructureSelection } from '../../../common/structure-selection/structure-selection.model';

@Component({
  selector: 'yard-position-condition-editor',
  standalone: false,
  templateUrl: './position-condition-editor.component.html',
  styleUrl: './position-condition-editor.component.scss',
})
export class PositionConditionEditorComponent implements OnInit, ConditionEditorContextConsumer {

  condition: ConditionEntry;

  currentSelection: any;

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        if (this.condition?.data) {
          this.currentSelection = new StructureSelection(JSON.parse(this.condition.data));
        }
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {

  }

  onSelectionChanged(selection: StructureSelection) {
    this.currentSelection = selection;
    this.condition.data = JSON.stringify(selection);
  }

}
